import { render, staticRenderFns } from "./form-declaration-generique.vue?vue&type=template&id=18b1c245"
import script from "./form-declaration-generique.vue?vue&type=script&lang=ts"
export * from "./form-declaration-generique.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports